(function($) {

$(document).ready(function(){

  if ($('.category').length) {
    var filterQuery = getUrlParameter('filter');
    if (filterQuery.length > 0) {
      $('#js-season-filter').siblings('span').html('<b>Sort By:</b> ' + filterQuery);
    }

    $('.category-filters__item').on('click', function() {

      if ($(this).hasClass('active')) {
        $(this).removeClass('active');

        $(this).find('ul').stop().slideUp(250);

      } else {
        $(this).addClass('active').siblings().removeClass('active');

        $(this).siblings().find('ul').stop().slideUp(250);

        $(this).find('ul').css('display', 'none').stop().slideDown(250);
      }

    });

    $('#js-season-filter li').on('click', function() {
      var filter = $(this).text();
      var queryStr = '?filter=';
      queryStr += filter.toLowerCase();

      var currentURL = window.location.href.split('?');

      window.location = currentURL[0] + queryStr;
    });


    function getUrlParameter(name) {
      name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
      var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
      var results = regex.exec(location.search);
      return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    };
  }

  //share modal
  $('.hv-post__share').on('click',function(){
    $('.share-modal').fadeIn();
  });
  $('.hv-post .share-modal').on('click',function(e){
    if ($(e.target).hasClass('share-modal')) {
      $('.share-modal').fadeOut();
    }
  });
  $('.hv-post .share-modal__close').on('click',function(){
    $('.share-modal').fadeOut();
  });
  $('.hv-post .share-modal__box__options span').on('click',function(){
    $(this).append('<b style="font-weight:normal;margin-left:10px;">Copied!</b>');
    $(this).find('b').fadeOut(800,function(){$(this).remove();});
    var dummy = document.createElement('input'),
      text = window.location.href;

    document.body.appendChild(dummy);
    dummy.value = text;
    dummy.select();
    document.execCommand('copy');
    document.body.removeChild(dummy);
  });

});

})( jQuery );
